module.exports = __webpack_public_path__ + "img/jc.d0289dc0.png";